import React from 'react';
import { useHistory } from 'react-router';

function LandingPage() {
  const history = useHistory();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#0f0f0f',
        color: '#ffffff',
        textAlign: 'center',
        padding: '20px',
      }}
    >
      <p style={{ fontSize: '20px', marginBottom: '8px' }}>ไม่ได้เข้าสู่ระบบ</p>
      <p style={{ fontSize: '16px', color: '#aaaaaa', marginBottom: '32px' }}>
        กรุณาล็อกอินใหม่อีกครั้ง
      </p>
    </div>
  );
}

export default LandingPage;
